<app-dashboard-container class="dashboard-toets" [factTable]="factTable" (doExport)="this.doExport(filterExpressions(), permanentFilters(), $event)">
	<app-filter-panel
		[defaultFilters]="toetsFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/cijfers"
		[permanentFilterExpressions]="permanentFilters()"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-single-select-dropdown
				label="Cijfertype"
				[opties]="cijferkolomKeuzeOpties()"
				[selectedOptie]="getSelectedCijfertypeOptie()"
				(onOptieClicked)="qp.dispatch('cijfertype', $event)"
			></app-single-select-dropdown>
			@if (cijferkolomKeuze() !== CijferkolomKeuze.GEMIDDELDE && userService.bron() === InstellingBron.Somtoday) {
				<app-single-select-dropdown
					label="Toetsdossier"
					[opties]="dossierOpties"
					[selectedOptie]="getSelectedDossierOptie()"
					(onOptieClicked)="qp.dispatch('dossier', $event)"
				></app-single-select-dropdown>
			}
			<app-legenda class="cl-header-utility" [attribute]="['x_cijfer_ov_advies']"></app-legenda>
		</app-dashboard-header>
		<app-pivot-table
			[tableGroups]="tableGroups"
			[groups]="groeperingService.huidigeGroeperingen()"
			[subgroups]="subgroups"
			[columnSort]="sortToetsKolommen"
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilters()"
			[config]="this"
		></app-pivot-table>
	</section>
</app-dashboard-container>
